import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from "@angular/router";
import { environment } from '../../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { forkJoin } from 'rxjs';
import bearerToken from '../../../../../assets/configurator/token_temporary.json';
import * as clevertap from 'clevertap-web-sdk';

@Injectable({
  providedIn: 'root'
})
export class ConfLobControlService {

  url = environment.configurationurl;
  private httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private router: Router, private http: HttpClient, private cookie_service: CookieService) { }

  length_of_parameters: any;
  next_no: any = 0
  routeArray: any = []

  public pdfservice = new Subject();

  public vasSecondPopupData = new Subject();
  // public vasData = new Subject();
  vasSecondPopupData$ = this.vasSecondPopupData.asObservable();


  private vasData$ = new BehaviorSubject<any>({});
  selectedVasData$ = this.vasData$.asObservable();

  public bodyBuilderData = new Subject();
  public fetchOnRoadData = new Subject();
  public grossPriceBreakUpStatus = new Subject();
  public brtInputData = new BehaviorSubject<any>([]);
  brtInputData$ = this.brtInputData.asObservable()

  pdfservice$ = this.pdfservice.asObservable();
  get_all_final_data(data: any) {
    this.pdfservice.next(data);
  }

  public sharePostdatetime = new Subject();
  sharePostdatetime$ = this.sharePostdatetime.asObservable();

  get_pdf_data(UpdateDatetime: any) {
    this.sharePostdatetime.next(UpdateDatetime);
  }

  private confDataPass = new BehaviorSubject<Array<any>>([]);
  public shareConfData = this.confDataPass.asObservable();
  updateConfData(data: any) {
    this.confDataPass.next(data);
  }

  public updateprogressstatus = new Subject();
  updateprogressstatus$ = this.updateprogressstatus.asObservable();
  updatestatus_(status: any) {
    if (status.serial === 0) {
      this.routeArray = []
    }
    this.routeArray.push(this.router.url)
    this.updateprogressstatus.next(status);
  }

  public updateprogressstatus_ = new Subject();
  updateprogressstatus_$ = this.updateprogressstatus_.asObservable();
  updatestatus_1(status: any) {
    if (status.serial === 0) {
      this.routeArray = []
    }
    this.countervalue(status.serial);
    this.updateprogressstatus_.next(status);
  }

  private confDataRoute = new BehaviorSubject<Array<any>>([]);
  public shareConfDataRoute = this.confDataRoute.asObservable();
  updateConfDataRoute(data: any) {
    this.confDataRoute.next(data);
  }

  private confLOBSelected = new BehaviorSubject<any>({});
  public shareConfLOBSelected = this.confLOBSelected.asObservable();
  updateConfLOBSelect(data: any) {
    this.confLOBSelected.next(data);
  }

  public serial_no_counter = new Subject();
  serial_no_counter$ = this.serial_no_counter.asObservable();
  countervalue(serial: any) {
    this.serial_no_counter.next(serial);
  }

  public next_button_event = new Subject();
  next_button_event$ = this.next_button_event.asObservable();
  next_button(status: any) {
    this.next_button_event.next(status);
  }


  public footerStatus = new Subject();
  footerStatusEvent = this.footerStatus.asObservable();
  toggleFooterStatus(status: any) {
    this.footerStatus.next(status);
  }

  // Handle Error
  handleError(error: HttpErrorResponse) {
    //alert('Status : ' + error.status);
    return throwError(error.status);
  }



  /**
   * Fetch all the data according to user select wise.
   * Request: POST
   * Parameter => Url: to call the api method, Payload: to filter according to selection
   */

  userReqPost(url: any, payload: any): Observable<any> {
    return this.http.post(environment.configurationurl + url + "/", payload)
  }

  /**
   * Pass selected data from one component to another
   * Update each component data inside the service
   * Will be removed once statemanagement is added
   */

  private confValueChange = new BehaviorSubject<any>("");
  public shareConfSelectedData = this.confValueChange.asObservable();
  updateConfChangeData(selctedData: any) {
    this.confValueChange.next(selctedData);
  }

  // ------------- By Kartik for Fetch On Road Price- START --------------------

  getOnRoadPriceData(url: any, data: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    // let authToken: any = this.cookie_service.get("access_token") // OSP team

    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    return this.http.post(environment.configurationurl + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  // ------------- By Kartik for Fetch On Road Price - END --------------------


  /**
   * Called parallel post request to fetch several base vehicle images together.
   * putDataParallel -> to call request parallely
   * param: URL -> passed from the component
   */

  postDataQAParallel(postUrl: any, payload: any) {
    let postRes: any = []
    let response: any;

    // let authToken: any = bearerToken.token
    let authToken: any = this.cookie_service.get("access_token") // OSP team

    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);

    const reqs = payload.map((data: any) => {
      response = this.http.post(environment.configurationurl + postUrl + "/", data, { headers: headers })
      postRes.push(response);
    });


    return forkJoin(postRes)
  }

  // ----------------- By Kartik for VAS Data Handling START ----------------

  setVasSecondPopupData(vasTerrainAndAvgMonthlyKm: any) {
    this.vasSecondPopupData.next(vasTerrainAndAvgMonthlyKm);
  }

  // getVasSecondPopupData() {
  //   return this.vasSecondPopupData;
  // }

  setVasData(userVasData: any) {
    this.vasData$.next(userVasData);
  }

  //  getVasData() {
  //   return this.vasData$;
  //  }
  // ----------------- By Kartik for VAS Data Handling END ----------------

  // ----------------- By Kartik for FETCH ON ROAD Data Handling START ----------------

  setBodyBuilderData(bodyBuilderData: any) {
    this.bodyBuilderData.next(bodyBuilderData);
  }

  getBodyBuilderData() {
    return this.bodyBuilderData;
  }

  setFetchOnRoadData(fetchOnRoadData: any) {
    this.fetchOnRoadData.next(fetchOnRoadData);
  }

  getFetchOnRoadData() {
    return this.fetchOnRoadData;
  }

  setGrossPriceBreakUpStatus(status: any) {
    this.grossPriceBreakUpStatus.next(status);
  }

  getGrossPriceBreakUpStatus() {
    return this.grossPriceBreakUpStatus;
  }

  setBrtInputData(inputData: any) {
    this.brtInputData.next(inputData);

  }
  // ----------------- By Kartik for FETCH ON ROAD Data Handling END ----------------

  /*-------------------------------------- Token Based Methods -------------------------------------*/
  getVasPriceData(url: any, data: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    return this.http.post(environment.configurationurl + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  getConfDataAuthenticate(url: any, data: any, auth_token: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    return this.http.post(environment.configurationurl + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }
  getConfFilterData(url: any, data: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    if (url == 'osp_configurator_get_images') {
      delete data['lob'];
    }
    return this.http.post(environment.configurationurl + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }
  getLobFilterData(url: any, data: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    if (url == 'osp_configurator_get_images') {
      delete data['lob'];
    }
    return this.http.post(environment.configurationurl + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  saveCleverTapEvt(eventName: any, evntObj: any) {
        clevertap.event.push(eventName, evntObj);
  }
  /*---------------------------------------------------------------------------------------------*/

  public sharePostdatetime_ = new Subject();
  sharePostdatetime_$ = this.sharePostdatetime_.asObservable();

  updateDatetimeValue(UpdateDatetime:any) {
    this.sharePostdatetime_.next(UpdateDatetime);
  }

  ospApiCall(url: any, data: any): Observable<any> {
    let authToken: any = this.cookie_service.get("access_token") // OSP team
    let headers: any = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);

    return this.http.post(environment.apiUrl + "api/v2/cv_online/" + url + "/", data, { headers: headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  getVasBookingAmt(lob: any){
    let bookingAmt = 1000;

    if(lob == 'hcv' || lob == 'ilmcv' || lob == 'bus'){
      bookingAmt = 2000
    }

    return bookingAmt
  }

}
